import React from 'react'
import { Link } from 'react-router-dom'

// Shown instead of the new-email form for accounts with Google/Apple sign-in
// linked: the account email has to match that Google/Apple email, so it can't
// be changed here. With a password set, they can unlink Google/Apple from the
// account page first and then update the email there; without one, they need
// to add a password first (which needs Google/Apple auth) — support is the
// fallback for anyone who no longer has access to that Google/Apple account.
const EmailVerificationUpdateEmailUnavailable = (props) => {
  const {
    externalSigninName, hasPassword, onBack, onGoToAccountPage,
  } = props

  return (
    <div className='emailVerificationFlow-backupOffer emailVerificationFlow-updateEmailUnavailable'>
      {onBack && (
        <button type='button' className='emailVerificationFlow-backBtn' onClick={onBack}>
          ← Back
        </button>
      )}
      <div className='emailVerificationFlow-title'>Update account email address</div>
      {hasPassword ? (
        <div className='emailVerificationFlow-description'>
          {`Your account email is linked to Sign in with ${externalSigninName}, so it can't be changed while that's on. To change it, remove Sign in with ${externalSigninName} `}
          <Link to='/account' onClick={onGoToAccountPage}>on the account page</Link>
          {' first, then update your email address there.'}
        </div>
      ) : (
        <React.Fragment>
          <div className='emailVerificationFlow-description'>
            {`Your account email is linked to Sign in with ${externalSigninName}, so it can't be changed while that's on. To change it, go to `}
            <Link to='/account' onClick={onGoToAccountPage}>the account page</Link>
            {' and:'}
          </div>
          <ul className='emailVerificationFlow-description emailVerificationFlow-steps'>
            <li>Add a password</li>
            <li>{`Remove Sign in with ${externalSigninName}`}</li>
            <li>Update your email address</li>
          </ul>
          <div className='emailVerificationFlow-description'>
            {`If you no longer have access to your ${externalSigninName} account, contact `}
            <a href='mailto:support@plickers.com'>support@plickers.com</a>
            {' and we\'ll help you update it.'}
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default EmailVerificationUpdateEmailUnavailable
